@if (hasData() || hasCitations() || hasError) {
<div class="performance-tracking-container">
    
    <!-- Error Message Display -->
    @if (hasError && errorMessage) {
    <div class="error-container" style="margin: 20px 0; padding: 20px; background-color: #ffebee; border-left: 4px solid #f44336; border-radius: 4px;">
        <h3 style="color: #c62828; margin-top: 0;">
            <mat-icon style="vertical-align: middle; margin-right: 8px;">error</mat-icon>
            Analysis Error
        </h3>
        <p style="color: #424242; margin-bottom: 0;">{{ errorMessage }}</p>
    </div>
    }
    
    <!-- Analysis Period Metadata -->
    <div class="metadata-section">
        <div class="metadata-item">
            <span class="metadata-label">Daily Analysis Period (Last 30 Days):</span>
            <span class="metadata-value">{{ getAnalysisPeriod() }}</span>
        </div>
        @if(projectData?.created_at || data?.metadata?.project_created_at){
        <div class="metadata-item">
            <span class="metadata-label">Project Created:</span>
            <span class="metadata-value">{{ (projectData?.created_at || data.metadata.project_created_at) | date:'MMM d, y' }}</span>
        </div>
        }
    </div>
    
    <!-- Chart 3: Your Brand Performance (Simple Bar Chart) -->
    @if(shouldRenderChart && barChartResults.length > 0){
    <div class="section">
        <h3 class="section-title">
            <mat-icon>bar_chart</mat-icon>
            Your Brand Performance
        </h3>
        <p class="section-description">Your brand visibility across different platforms and channels</p>
        <!-- <div class="chart-container" #chartContainer> -->
            <app-bar-line-combo-chart
                [results]="barChartResults"
                [barBrandName]="firstBrandName"
                [xAxisLabel]="'Platform Metrics'"
                [yAxisLabel]="'Score'"
                [legendTitle]="'Your Brand'">
            </app-bar-line-combo-chart>
        <!-- </div> -->
    </div>
    } @else if (!shouldRenderChart) {
    <div class="section">
        <h3 class="section-title">
            <mat-icon>bar_chart</mat-icon>
            Your Brand Performance
        </h3>
        <p class="section-description">Your brand visibility across different platforms and channels</p>
        <div class="chart-container">
            <div class="chart-placeholder">
                <p>Chart will load when tab becomes visible...</p>
            </div>
        </div>
    </div>
    } @else {
    <div class="section">
        <h3 class="section-title">
            <mat-icon>bar_chart</mat-icon>
            Your Brand Performance
        </h3>
        <p class="section-description">Your brand visibility across different platforms and channels</p>
        <div class="chart-container">
            <div class="chart-placeholder">
                <p>No data available for your brand performance</p>
                <p>Results length: {{ results.length }}</p>
                <p>Should render: {{ shouldRenderChart }}</p>
            </div>
        </div>
    </div>
    }

    <!-- Trend Analysis -->
    @if(hasTrendData()){
    <div class="section">
        <h3 class="section-title">
            <mat-icon>timeline</mat-icon>
            Daily Brand Visibility Trends 
        </h3>
        <p class="section-description">Track daily brand visibility performance over the last 30 days with detailed day-by-day metrics</p>

        <!-- Trend Line Chart -->
        @if(trendLineData.length > 0){
        <div class="chart-container daily-trend-chart">
            <!-- <h4>Daily Visibility Trends (Last 30 Days)</h4>
            <p class="chart-description">{{ getBrandName() }} daily visibility performance from {{ getAnalysisPeriod() }}</p> -->
            <app-bar-line-combo-chart
                [results]="[]"
                [lineChart]="trendLineData"
                [barBrandName]="getBrandName()"
                [xAxisLabel]="'Date'"
                [yAxisLabel]="'Visibility Score'"
                [legendTitle]="'Daily Visibility Trends'"
                [legend]="true"
                [yAxisStartAtZero]="false"
                [showPoints]="false"
                [dateGapInterval]="4"
                [lineColor]="'#a8385d'">
            </app-bar-line-combo-chart>
        </div>
        }

    </div>
    }

    <!-- Chart 1: Performance Metrics Comparison (Radar Chart) -->
    @if(performanceRadarData.length > 0){
    <div class="section">
        <h3 class="section-title">
            <mat-icon>radar</mat-icon>
            Brand Visibility Metrics Comparison
        </h3>
        <p class="section-description">Compare brand visibility across different platforms and channels</p>
        <app-area-chart [areaChartData]="performanceRadarData" [scheme]="'vivid'" [animations]="true" [legend]="false" [xAxis]="true" [yAxis]="true" [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="''" [yAxisLabel]="''">
        </app-area-chart>
    </div>
    }
    
    <!-- HIDDEN: Sources & Citations (do not remove)
    @if (hasCitations()) {
    <app-citation-card
      [citations]="mappedCitations"
      [title]="'Sources & Citations'"
      [displayStyle]="'grid'"
      [maxDisplay]="20">
    </app-citation-card>
    }
    -->

</div>
} @else {
<!-- No Data State -->
<div class="no-data-container" style="padding: 40px; text-align: center;">
    <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #ccc; margin-bottom: 16px;">bar_chart</mat-icon>
    <h3 style="color: #666; margin-bottom: 8px;">No Performance Tracking Data Available</h3>
    <p style="color: #999;">Unable to load performance tracking data at this time.</p>
    <!-- HIDDEN: Sources & Citations (do not remove)
    @if (hasCitations()) {
    <app-citation-card
      [citations]="mappedCitations"
      [title]="'Sources & Citations'"
      [displayStyle]="'grid'"
      [maxDisplay]="20">
    </app-citation-card>
    }
    -->
</div>
}
